class AuthTokenStorage {
    keyStorage = "authTokenWorkflowStorage";

    public save(token: string) {
        localStorage.setItem(this.keyStorage, token);
    }

    public get(): string | null {
        return localStorage.getItem(this.keyStorage) 
    }

    public removeFromStorage() {
        localStorage.removeItem(this.keyStorage);
    }
}

export const authTokenStorage = new AuthTokenStorage();